'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const tslib = require('tslib');
const createRenderState = require('../../html/utils/create-render-state.js');

var createSvgRenderState = function () {
  return tslib.__assign(tslib.__assign({}, createRenderState.createHtmlRenderState()), {
    attrs: {}
  });
};

exports.createSvgRenderState = createSvgRenderState;
